import { render } from "./ProfileInfo.vue?vue&type=template&id=4e96b528&scoped=true&ts=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts"

import "./ProfileInfo.vue?vue&type=style&index=0&id=4e96b528&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e96b528"]])

export default __exports__